type NewTabEventLike = {
  metaKey?: boolean;
  ctrlKey?: boolean;
  button?: number;
};

/** 支持 cmd/ctrl + click 和中键打开新标签页 */
export const shouldOpenInNewTab = (event: NewTabEventLike) =>
  Boolean(event.metaKey || event.ctrlKey || event.button === 1);

export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
